<template>
  <div>
    <el-divider></el-divider>
    <div>
      <div class="table-wrap">
        <el-table
          v-loading="loading"
          :data="pageData.list"
          border
          style="width: 100%">
          <el-table-column
            prop="projectName"
            label="项目"
            width="180">
          </el-table-column>
          <el-table-column
            prop="username"
            label="姓名"
            width="180">
          </el-table-column>
          <el-table-column
            prop="position"
            label="职位"
            width="180">
          </el-table-column>
          <el-table-column
            prop="regionCount"
            label="管辖小区域数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="cfTaskCount"
            label="催费任务户数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="cjTaskCount"
            label="抽检任务户数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="houseCount"
            label="实际抽检户数"
            width="150">
          </el-table-column>
          <el-table-column
            prop="checkHousePercent"
            label="抽检率"
            width="110">
          </el-table-column>
          <el-table-column
            prop="count"
            label="抽检次数"
            width="110">
          </el-table-column>
          <el-table-column
            prop="averageDuration"
            label="平均时长"
            width="110">
          </el-table-column>
          <el-table-column
            prop="checkDate"
            label="抽检日期">
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
         :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
         @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Track from "../../../../../assets/js/trackHttp";
import moment from "moment";

export default {
  name: "TaskRecordCount",
  inject:['where','reginWhere'],
  data(){
    return{
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      all_count:0,
      from_data:{},
      dialogVisible:false,
      tree_obj:null,
      loading: false,
    }
  },
  mounted() {
    this.getList()
    // this.getAjaxCount()
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.start_time":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.end_time":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.user_name":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.date_range":function (n,o) {
      this.pageChange(1);
    },
    "reginWhere.record_type":function (n,o) {
      this.pageChange(1);
    },
  },
  methods:{
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getList() {
      const that = this;
      that.loading = true;
      // let where = ERP.reJson(that.where);
      let start_time = that.reginWhere.start_time ?  that.reginWhere.start_time : moment(new Date()).format("YYYYMMDD");
      let end_time = that.reginWhere.end_time ?  that.reginWhere.end_time : moment(new Date()).format("YYYYMMDD");
      let where = {
        project_ids:that.reginWhere.project_ids,
        project_regin: that.reginWhere.project_region,
        project_id:that.reginWhere.project_name,
        // start_time: that.reginWhere.start_time,
        user_name: that.reginWhere.user_name,
        // record_type: that.reginWhere.record_type,
        date_range: [start_time,end_time]
        // date_range: that.reginWhere.date_range
      }

      // console.log('where', where);

      // 请求
      Track.post('track/taskCount', {...where, page: that.pageData.page,page_size: that.pageData.pageSize}, res => {
        that.loading = false;
        // console.log('请求结果', res);
        if (res.code === 200) {
          that.pageData.list  = res.data.data;
          that.pageData.total = res.data.total;
        }
      })
      //
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";

.m-2{
  width: 150px;
}
.ti {
  margin: 1%;
  width: 98%;
}

.text1 {
  text-align: center;
}

.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}

.search {
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}

.text2 {
  color: rgb(250, 248, 248);
}

.kuan {
  width: 10%;
}

.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  margin: 30px;
  width: calc( 100% - 10px );
  overflow-y: scroll;
  height: calc( 100vh - 150px );

  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }

  .btn-item {
    margin-top: 10px;
    margin-right: 30px;
  }

  >>>.el-tabs__item{
    color: black;
  }
}
.view-file-win{
  height: 60vh;
  overflow-y: scroll;
  .main-log{
    margin: 10px 20px;
  }
}
.header-btn2{
  .btn-item{
    margin: 10px 20px;
  }
}
.pagination-wrap {
  text-align: center;
  justify-content: center;
  margin-top: 15px;
  margin-bottom: 15px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/taskrecord/TaskRecordCount.vue